export default __webpack_public_path__ + "static/media/geomap.png?.d512f7cd";